export interface ReleaseManifest {
  id: string;
  title: string;
  date: string;
  summary?: string;
  items?: {
    new?: string[];
    improved?: string[];
    fixed?: string[];
  };
  notesUrl?: string;
}

export const CURRENT_RELEASE: ReleaseManifest = __SPUERHUND_RELEASE_MANIFEST__;

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((entry) => typeof entry === "string");
}

export function isReleaseManifest(value: unknown): value is ReleaseManifest {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Record<string, unknown>;
  if (typeof candidate.id !== "string") return false;
  if (typeof candidate.title !== "string") return false;
  if (typeof candidate.date !== "string") return false;
  if (candidate.summary !== undefined && typeof candidate.summary !== "string") return false;
  if (candidate.notesUrl !== undefined && typeof candidate.notesUrl !== "string") return false;

  if (candidate.items !== undefined) {
    if (!candidate.items || typeof candidate.items !== "object") return false;
    const items = candidate.items as Record<string, unknown>;
    if (items.new !== undefined && !isStringArray(items.new)) return false;
    if (items.improved !== undefined && !isStringArray(items.improved)) return false;
    if (items.fixed !== undefined && !isStringArray(items.fixed)) return false;
  }

  return true;
}

export async function fetchLatestReleaseManifest(): Promise<ReleaseManifest> {
  const response = await fetch("./release.json", {
    cache: "no-cache",
    headers: {
      "Cache-Control": "no-cache",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch release manifest: ${response.status}`);
  }

  const data: unknown = await response.json();
  if (!isReleaseManifest(data)) {
    throw new Error("Invalid release manifest");
  }

  return data;
}
